import moment, { Moment } from 'moment';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'antd';

import {
  Button,
  ICONS,
  PLATFORM_THEME_COLORS,
  Typography,
} from '@thinknet-gmbh/platform-common-ui';

import { ButtonWrapper, DropdownWrapper, DropdownElement } from './time-copy-button.styles';
import { removeDuplicatedTime } from './time-copy-button.helpers';

const TimeCopyButton = ({
  selectedDays,
  setSelectedDays,
}: {
  selectedDays: { day: string; value: Moment[] | null }[];
  setSelectedDays: (values: any) => void;
}) => {
  const { t } = useTranslation(['common', 'employee']);

  const getTimeValue = (value: Moment[] | null) => {
    setSelectedDays(
      selectedDays.map(item => {
        if (item.value) {
          return item;
        }
        return { ...item, value };
      })
    );
  };

  return (
    <Dropdown
      placement="bottomCenter"
      trigger={['click']}
      getPopupContainer={element => document.getElementById('wrapper') || element}
      overlay={
        <DropdownWrapper>
          {selectedDays.map(({ day, value }) => {
            const isDuplicated = removeDuplicatedTime(day, value, selectedDays);

            if (!value || isDuplicated) return null;

            const [from, to] = value;

            return (
              <DropdownElement key={day} onClick={() => getTimeValue(value)}>
                <Typography>{t(`common:days.${day}`)}:</Typography>
                <Typography>{`${moment(from).format('HH.mm')} - ${moment(to).format(
                  'HH.mm'
                )}`}</Typography>
              </DropdownElement>
            );
          })}
        </DropdownWrapper>
      }
    >
      <ButtonWrapper id="wrapper">
        <Button type="text" icon={ICONS.copy} iconColor={PLATFORM_THEME_COLORS.primary.blue}>
          {t('employee:buttons.copyTimeForAllDays')}
        </Button>
      </ButtonWrapper>
    </Dropdown>
  );
};

export default TimeCopyButton;
